<template>
  <div class="mx-10">
    <v-row align="center" class="pa-4">
      <v-col cols="6" class="px-4">
        <v-img :src="$t('general.logo')" max-height="200px" contain />
      </v-col>
      <v-col cols="6" class="px-4">
        <v-img :src="logoSrc" max-height="200px" contain />
      </v-col>
    </v-row>
    <v-row justify="center" no-gutters>
      <v-col
        v-for="(shortcut, index) in shortcutList"
        :key="`shortcut-${index}`"
        cols="6"
        md="4"
        xl="3"
      >
        <v-card
          :to="shortcut.link"
          class="item-link-card text-center py-5 ma-3 px-1"
        >
          <v-row
            justify="center"
            align="center"
            no-gutters
            style="min-height: 50px"
          >
            <v-col cols="auto">
              <v-icon large class="ml-10" v-text="shortcut.icon" />
            </v-col>
            <v-col>
              <span class="text-h6 grey--text text--darken-3" v-text="shortcut.title" />
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
    <ag-card-container
      v-if="hasTrainedPlayer"
      centered
      :title="$t('company.title.trainedPlayerChart')"
      fluid
    >
      <trained-player-chart :value="trainedPlayerQtyByMonth" style="height: 250px" />
    </ag-card-container>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Config from 'src/config'
import MenuService from 'src/services/menu'
import Repositories from 'src/repositories'
import AgCardContainer from 'src/components/common/AgCardContainer'
import TrainedPlayerChart from 'src/modules/company/components/TrainedPlayerChart'

export default {
  name: 'HomeContainer',
  components: {
    AgCardContainer,
    TrainedPlayerChart,
  },
  data () {
    return {
      trainedPlayerQtyByMonth: null,
    }
  },
  computed: {
    ...mapGetters('me', {
      company: 'company',
      roles: 'roles',
    }),
    logoSrc () {
      return `${Config.API_URL}company/${this.company.id}/logo/${this.company.logo}`
    },
    shortcutList () {
      return MenuService.getShortcutList('home', this.roles, { i18n: this.$i18n })
    },
    hasTrainedPlayer () {
      return this.trainedPlayerQtyByMonth?.some(item => item.qty)
    },
  },
  async mounted () {
    this.trainedPlayerQtyByMonth = await Repositories.myCompany.getTrainedPlayerQtyByMonth()
  },
}
</script>

<style lang="scss" scoped>
  .item-link-card {
    overflow: hidden !important;
    transition: all 0.1s linear !important;
  }

  .item-link-card:hover {
    transform: translateY(-5px) scale(1.02) !important;
    box-shadow: 0 10px 10px rgba(0, 0, 0, 0.3) !important;
  }
</style>
